<template>
	<div v-if="ratingsForm.stars && ratingsForm.stars !== ''" class="location-google-reviews">
		<GlobalIcon name="google-icon" :width="16" />
		<div class="location-google-reviews__divider"></div>
		<div class="location-google-reviews__container">
			<div class="location-google-reviews__stars">
				<GlobalRating
					:rating="ratingsForm.stars"
					readonly
					colorFilled="var(--primary-color)"
					colorEmpty="var(--primary-color)"></GlobalRating>
			</div>
			<p class="location-google-reviews__text">
				{{ formatRating(ratingsForm.ratings) }},
				<a :href="ratingsForm?.url" target="_blank" class="location-google-reviews__link">
					{{ ratingsForm.ratingsCount }} {{ $t('components.booker.google_reviews.opinions') }}
				</a>
			</p>
		</div>
	</div>
</template>

<script setup lang="ts">
const ratingsForm = reactive({
	stars: '',
	ratings: '',
	ratingsCount: '',
	url: '',
})

const assignedLocations = inject<Ref<ILocationModel[]>>('assignedLocations')!
const googleRatingsStore = useGoogleRatingsStore()

watch(
	() => assignedLocations.value,
	(v) => {
		if (v[0] && v[0].countRatings && v[0].googleUrl && v[0].ratings) {
			ratingsForm.stars = v[0].ratings
			ratingsForm.ratings = v[0].ratings
			ratingsForm.ratingsCount = v[0].countRatings
			ratingsForm.url = v[0].googleUrl
		} else {
			// branch has no Google reviews of its own - fall back to the company-wide reviews (same as the home page)
			googleRatingsStore.fetchGoogleRating()
		}
	},
	{ deep: true, immediate: true },
)

watch(
	() => googleRatingsStore.getGoogleRating,
	(v) => {
		if (v && !ratingsForm.stars) {
			ratingsForm.stars = String(v.stars)
			ratingsForm.ratings = String(v.ratings)
			ratingsForm.ratingsCount = String(v.ratingsCount)
			ratingsForm.url = v.url
		}
	},
	{ immediate: true },
)
</script>

<style lang="scss" scoped src="./GoogleReviews.scss"></style>
